// @ts-ignore
import * as Vue from 'vue';
var allVue = Vue;
var gh = allVue.h;
var ref = allVue.ref;
/**
 * Represents the default `SearchBar` component.
 */

var SearchBar = {
  name: 'search-bar',
  // @ts-ignore
  emits: {
    'change': null,
    'keydown': null,
    'focus': null,
    'blur': null
  },
  props: {
    value: String,
    id: String,
    placeholder: String,
    tabIndex: Number,
    size: {
      type: Number,
      default: undefined
    },
    suggestedText: String,
    focused: Boolean,
    disabled: Boolean,
    readOnly: Boolean,
    expanded: Boolean,
    owns: String,
    name: String,
    activedescendant: String,
    describedby: String,
    clearButton: Boolean,
    accessKey: String
  },
  data: function data() {
    return {
      prevValue: undefined,
      prevSuggestedText: undefined
    };
  },
  watch: {
    suggestedText: function suggestedText(_, oldValue) {
      this.prevSuggestedText = oldValue;
    },
    value: function value(_, oldValue) {
      this.prevValue = oldValue;
    }
  },
  updated: function updated() {
    var _a = this.$props,
        value = _a.value,
        suggestedText = _a.suggestedText,
        focused = _a.focused;

    if (!this.input) {
      this.input = this.$refs.input;
    }

    var input = this.input;
    var valueChanged = this.$data.prevValue !== value || suggestedText !== this.prevSuggestedText;
    var deleting = valueChanged && this.$data.prevValue && this.$data.prevValue.startsWith(value) && !(this.$data.prevSuggestedText && suggestedText && this.$data.prevSuggestedText.endsWith(suggestedText));

    if (focused && input && document.activeElement !== input) {
      input.focus();
    }

    if (suggestedText && valueChanged && !deleting && input) {
      input.setSelectionRange(value.length - suggestedText.length, value.length);
    }
  },
  // @ts-ignore
  setup: !gh ? undefined : function () {
    var v3 = !!gh;
    var inputRef = ref(null);
    return {
      v3: v3,
      inputRef: inputRef
    };
  },
  mounted: function mounted() {
    this.input = this.v3 ? this.inputRef : this.$refs.input;
  },
  methods: {
    onChange: function onChange(e) {
      this.$emit('change', e);
    },
    onBlur: function onBlur(e) {
      this.$emit('blur', e);
    },
    onFocus: function onFocus(e) {
      this.$emit('focus', e);
    },
    onKeyDown: function onKeyDown(e) {
      this.$emit('keydown', e);
    },
    clearButtonClick: function clearButtonClick(e) {
      this.$emit('clearbuttonclick', e);
    }
  },
  // @ts-ignore
  render: function render(createElement) {
    var _this = this;

    var h = gh || createElement;
    var suggestedText = this.$props.suggestedText;
    return h("span", {
      "class": "k-searchbar",
      key: "searchbar"
    }, [h("input", {
      autoComplete: "off",
      attrs: this.v3 ? undefined : {
        autoComplete: "off",
        id: this.$props.id,
        type: "text",
        placeholder: this.$props.placeholder,
        tabIndex: this.$props.tabIndex,
        accessKey: this.$props.accessKey,
        role: "listbox",
        name: this.$props.name,
        size: this.$props.size ? this.$props.size : 20,
        "aria-disabled": this.$props.disabled || undefined,
        disabled: this.$props.disabled || undefined,
        readOnly: this.$props.readOnly || undefined,
        "aria-haspopup": "listbox",
        "aria-expanded": this.$props.expanded || false,
        "aria-owns": this.$props.owns,
        "aria-activedescendant": this.$props.activedescendant,
        "aria-describedby": this.$props.describedby
      },
      id: this.$props.id,
      type: "text",
      placeholder: this.$props.placeholder,
      "class": "k-input",
      tabIndex: this.$props.tabIndex,
      accessKey: this.$props.accessKey,
      role: "listbox",
      name: this.$props.name,
      value: this.v3 ? this.$props.value : null,
      domProps: this.v3 ? undefined : {
        "value": this.$props.value
      },
      size: this.$props.size ? this.$props.size : 20,
      onInput: this.onChange,
      on: this.v3 ? undefined : {
        "input": this.onChange,
        "keydown": this.onKeyDown,
        "focusin": this.onFocus,
        "blur": this.onBlur
      },
      ref: this.v3 ? function (el) {
        _this.inputRef = el;
      } : 'input',
      onKeydown: this.onKeyDown,
      onFocusin: this.onFocus,
      onBlur: this.onBlur,
      "aria-disabled": this.$props.disabled || undefined,
      disabled: this.$props.disabled || undefined,
      readOnly: this.$props.readOnly || undefined,
      "aria-haspopup": "listbox",
      "aria-expanded": this.$props.expanded || false,
      "aria-owns": this.$props.owns,
      "aria-activedescendant": this.$props.activedescendant,
      "aria-describedby": this.$props.describedby
    })]);
  }
};
export { SearchBar };


//////////////////
// WEBPACK FOOTER
// ./~/@progress/kendo-vue-dropdowns/dist/es/common/SearchBar.js
// module id = 226
// module chunks = 93